module.exports = __webpack_public_path__ + "img/qrcode.535a8359.png";